// Modules.
import { connect } from 'react-redux';

// Components.
import LoginMenuItem from './LoginMenuItem';

// Store.
const mapStateToProps = state => ({
    gvars: state.global.gvars,
});

export default connect(mapStateToProps)(LoginMenuItem);
